/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_No_Members_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "No members match your current search criteria. Try adjusting your search." |
*
* @param {Members_No_Members_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_no_members_found_description = /** @type {((inputs?: Members_No_Members_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_No_Members_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Mitglieder entsprechen deinen Suchkriterien. Versuche, deine Suche anzupassen.")
	return /** @type {LocalizedString} */ ("No members match your current search criteria. Try adjusting your search.")
});